import { motion } from "framer-motion";
import { ANIMATION_TIMING, EASING_CURVES } from "../utils/motion";
import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
import ReactMarkdown from "react-markdown";

const CustomFooter = ({ textes, isBackgroundWhite }) => {
  return (
    <motion.footer
      className="footer-section py-16 "
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: ANIMATION_TIMING.durations.slow,
        delay: 0.4,
        ease: EASING_CURVES.smooth,
      }}
    >
      <motion.div
        className="relative flex py-5 items-center w-full text-center mt-20 w-screen mx-auto"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{
          duration: ANIMATION_TIMING.durations.normal,
          delay: 0.5,
          ease: EASING_CURVES.smooth,
        }}
      >
        <div class="flex-grow border-t border-gray-400"></div>
        <p
          className={
            "text-6xl md:text-6xl flex-shrink mx-4 max-w-[18vw] " +
            (isBackgroundWhite ? "text-black" : "text-white")
          }
          style={{ fontFamily: "Lexend" }}
        >
          Un projet <span className="font-sam color-primary"> animé</span> et{" "}
          <span className="font-sam color-primary">mouvementé</span> ?
        </p>
        <div class="flex-grow border-t border-gray-400"></div>
      </motion.div>
      <motion.div className="mx-auto">
        <div className="flex flex-row gap-16 items-center">
          {/* Left side - "Un projet animé et mouvementé ?" */}
          <div className="w-1/3 flex flex-col items-center pl-24">
            <motion.div
              className="flex text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: ANIMATION_TIMING.durations.normal,
                delay: 0.6,
                ease: EASING_CURVES.smooth,
              }}
            >
              <h2
                className={
                  "text-8xl md:text-8xl " +
                  (isBackgroundWhite ? "text-black" : "text-white")
                }
                style={{ fontFamily: "SAM" }}
              >
                sam
              </h2>
            </motion.div>
            <div class="relative flex py-5 items-center w-[40%]">
              <div class="flex-grow border-t border-gray-400"></div>
              {/* <span class="flex-shrink mx-4 text-gray-400">Content</span> */}
              <div class="flex-grow border-t border-gray-400"></div>
            </div>
            <motion.div
              className="flex space-x-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: ANIMATION_TIMING.durations.normal,
                delay: 0.8,
                ease: EASING_CURVES.smooth,
              }}
            >
              <motion.a
                href={textes?.facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className={` hover:text-green-400 transition-colors duration-300 ${
                  isBackgroundWhite ? "text-black" : "text-white"
                }`}
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaFacebookF size={26} />
              </motion.a>
              <motion.a
                href={textes?.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className={` hover:text-green-400 transition-colors duration-300 ${
                  isBackgroundWhite ? "text-black" : "text-white"
                }`}
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaInstagram size={26} />
              </motion.a>
              <motion.a
                href={textes?.linkedinLink}
                target="_blank"
                rel="noopener noreferrer"
                className={` hover:text-green-400 transition-colors duration-300 ${
                  isBackgroundWhite ? "text-black" : "text-white"
                }`}
                whileHover={{ scale: 1.2, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaLinkedin size={26} />
              </motion.a>
            </motion.div>
          </div>

          {/* Right side - email and copyright */}
          <motion.div
            className="w-1/3 text-center space-y-4"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: ANIMATION_TIMING.durations.normal,
              delay: 0.7,
              ease: EASING_CURVES.smooth,
            }}
          >
            <motion.a
              href="mailto:bonjour@studio-sam.fr"
              className={`border-[#00FFCC] border-2 p-6 text-4xl ${
                isBackgroundWhite ? "text-black" : "text-white"
              }`}
              style={{ fontFamily: "Lexend" }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              bonjour@<span className="font-sam color-primary">studio-sam</span>
              .fr
            </motion.a>
          </motion.div>

          <motion.div
            className={`text-center w-1/3 ${
                  isBackgroundWhite ? "text-black" : "text-white"
                }`}
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: ANIMATION_TIMING.durations.normal,
              delay: 0.7,
              ease: EASING_CURVES.smooth,
            }}
          >
            <ReactMarkdown
              className="font-medium text-3xl"
              escapeHtml={false}
              components={{
                strong: ({ node, ...props }) => (
                  <span className="text-strong" {...props} />
                ),
              }}
              style={{
                fontFamily: "Lexend",
              }}
            >
              {textes?.allRightsReserved + new Date().getFullYear()}
            </ReactMarkdown>
          </motion.div>
        </div>
      </motion.div>
    </motion.footer>
  );
};

export default CustomFooter;
